/**
 * @file BaseClinicComponent.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Clinic } from "../../../services/models/Clinic";
import { BaseComponent } from "./BaseComponent";

/**
 * A class definition for ClinicInfo
 */
export class ClinicInfo {
    id: string;
    name: string;
    isSelected = false;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

/**
* A class definition for BaseClinicComponent
*/
export class BaseClinicComponent<BaseProps, State> extends BaseComponent<BaseProps, State> {

    protected clinicList: ClinicInfo[] = [];
    protected filteredClinicList: ClinicInfo[];
    protected selectedClinic: Clinic;

    constructor(props: BaseProps) {
        super(props);
    }

    /**
     * Modifies clinics
     * @param clinics Clinic[]
     */
    protected modifyClinic(clinics: Clinic[], selectedClinic?: Clinic) {
        clinics.forEach(clinic => {
            const clinicInfo = new ClinicInfo(clinic.id!!, clinic.name!!); // eslint-disable-line
           
            if(selectedClinic && clinic.id === selectedClinic.id) {
                clinicInfo.isSelected = true;
                this.clinicList.unshift(clinicInfo); // eslint-disable-line
            } else {
                this.clinicList.push(clinicInfo); // eslint-disable-line
            }
        })
        this.filteredClinicList = this.clinicList;
    }

}